import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import { useParams } from "react-router-dom";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import AdVidsInMachineCreate from "pages/advertisement/ad_videos/in_machine/AdVidsInMachineCreate";
import AdVidsInMachineList from "pages/advertisement/ad_videos/in_machine/AdVidsInMachineList";

const AdVidsInMachine = () => {
  const { m_id } = useParams();
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Ads in machine "
        viewIcon={<OndemandVideoIcon />}
        createIcon={<VideoCallIcon />}
        createChildren={<AdVidsInMachineCreate m_id={parseInt(m_id)} />}
        listChildren={<AdVidsInMachineList m_id={parseInt(m_id)} />}
      />
    </Box>
  );
};

export default AdVidsInMachine;
